import { useState } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const PartsSearch = (props) => {

    const [partNumber, setPartNumber] = useState('');
    const [searchType, setSearchType] = useState('Start');

    const submitForm = (e) => {
        e.preventDefault();
        let url = props.searchURL;
        if (partNumber === '' && e.target[0] !== '') {
            url = url + '?PartNumber=' + e.target[0].value;
        } else {
            url = url + '?PartNumber=' + partNumber;
        }
        url = url + '&SearchType=' + searchType;
        window.location.href = url;
    };

    return (
        <div className='parts-container'>
            <form onSubmit={submitForm}>
                <div className='cf'>
                    <label htmlFor='part-search' className='part-label'>
                        <TranslationText tKey='sandhills.searchforparts' />
                    </label>
                    <input id='part-search' onChange={(e) => setPartNumber(e.target.value)} type='text' name='partNumber' placeholder={translator.translate('sandhills.partnum') + ', ' + translator.translate('sandhills.tradepubwebsite.mvc.example') + ': 1234'} />
                    <input className='ts-button' type='submit' value={translator.translate('sandhills.tradepubwebsite.mvc.search')} />
                </div>
                <div className='part-radio' role='radiogroup' aria-label='part search type'>
                    <span className='visually-hidden' id='part-search-type'>{translator.translate('sandhills.typeofsearch')}</span>
                    <label htmlFor='search-type-start'>
                        <input id='search-type-start' name='searchType' value='Start' type='radio' role='radio' checked={searchType == 'Start'} onChange={(e) => setSearchType(e.target.value)}  />
                        <TranslationText tKey='sandhills.tradepubwebsite.mvc.startswith' />
                    </label>
                    <label htmlFor='search-type-exact'>
                        <input id='search-type-exact' name='searchType' value='Exact' type='radio' role='radio' checked={searchType == 'Exact'} onChange={(e) => setSearchType(e.target.value)}  />
                        <TranslationText tKey='sandhills.tradepubwebsite.mvc.exactmatch' />
                    </label>
                </div>
            </form>
        </div>
    );
};

export default PartsSearch;